module.exports = __webpack_public_path__ + "static/media/paper_types_modal@2x.ff1b051e.jpg";